import React, { useState } from "react";
import { MiniBar } from "./stpHelpers";

const VIEWS = ["24h Flow", "pH Trend", "Weekly Volume"];

const StpInletPanel = ({ d }) => {
  const [view, setView] = useState("24h Flow");
  const { inlet } = d;
  const maxFlow   = Math.max(...inlet.hourlyTrend.map(x => x.flow));
  const maxVolume = Math.max(...inlet.weeklyTrend.map(x => x.volume));
  const maxPh = 9, minPh = 6;

  return (
    <div className="stp-inlet-panel">

      {/* KPI row */}
      <div className="stp-inlet-kpis">
        {[
          { label: "Flow Rate",     value: `${inlet.flowRate} m³/hr`,    color: "#667eea" },
          { label: "Daily Volume",  value: `${(inlet.dailyVolume/1000).toFixed(1)} kL`, color: "#3b82f6" },
          { label: "pH",            value: inlet.ph,          color: inlet.ph > 8.5 || inlet.ph < 6.5 ? "#ef4444" : "#10b981" },
          { label: "TSS",           value: `${inlet.tss} mg/L`, color: inlet.tss > 500 ? "#f59e0b" : "#10b981" },
          { label: "COD",           value: `${inlet.cod} mg/L`, color: "#8b5cf6" },
          { label: "BOD",           value: `${inlet.bod} mg/L`, color: "#f97316" },
        ].map(k => (
          <div key={k.label} className="stp-inlet-kpi" style={{ borderTopColor: k.color }}>
            <div className="stp-ik-val" style={{ color: k.color }}>{k.value}</div>
            <div className="stp-ik-lbl">{k.label}</div>
          </div>
        ))}
      </div>

      {/* Peak hours */}
      <div className="stp-peak-row">
        <span className="stp-peak-label">⏰ Peak Load Hours:</span>
        {inlet.peakHours.map(h => (
          <span key={h} className="stp-peak-chip">{h}</span>
        ))}
      </div>

      {/* View toggle */}
      <div className="stp-view-row">
        {VIEWS.map(v => (
          <button key={v} className={`stp-view-btn ${view === v ? "stp-view-active" : ""}`} onClick={() => setView(v)}>{v}</button>
        ))}
      </div>

      {/* Charts */}
      {view === "24h Flow" && (
        <div className="stp-chart-card">
          <div className="stp-section-title">24-Hour Inlet Flow Rate (m³/hr)</div>
          <div className="stp-bar-chart" style={{ height: 200 }}>
            {inlet.hourlyTrend.map(pt => (
              <div key={pt.t} className="stp-bar-col">
                <div className="stp-bar-val" style={{ fontSize: 8 }}>{pt.flow > 100 ? pt.flow : ""}</div>
                <div className="stp-bar-wrap">
                  <div className="stp-bar-fill" style={{
                    height: `${(pt.flow / maxFlow) * 100}%`,
                    background: pt.flow > 180 ? "linear-gradient(180deg,#ef4444,#f97316)" : "linear-gradient(180deg,#667eea,#3b82f6)"
                  }} />
                </div>
                <div className="stp-bar-lbl" style={{ fontSize: 8 }}>{pt.t.replace(":00","")}</div>
              </div>
            ))}
          </div>
          <div className="stp-chart-note">🔴 Bars indicate peak load periods (flow &gt; 180 m³/hr)</div>
        </div>
      )}

      {view === "pH Trend" && (
        <div className="stp-chart-card">
          <div className="stp-section-title">24-Hour Inlet pH Trend</div>
          <div className="stp-ph-chart">
            {inlet.hourlyTrend.map((pt, i) => {
              const pct = ((pt.ph - minPh) / (maxPh - minPh)) * 100;
              const col = pt.ph > 8.5 || pt.ph < 6.5 ? "#ef4444" : pt.ph > 8.0 ? "#f59e0b" : "#10b981";
              return (
                <div key={i} className="stp-ph-col">
                  <div className="stp-ph-wrap">
                    <div className="stp-ph-bar" style={{ height: `${pct}%`, background: col }} />
                  </div>
                  <div className="stp-ph-val">{pt.ph}</div>
                  <div className="stp-ph-lbl">{pt.t.replace(":00","")}</div>
                </div>
              );
            })}
          </div>
          <div className="stp-limit-lines">
            <span style={{ color: "#ef4444" }}>── Upper limit: 8.5</span>
            <span style={{ color: "#ef4444" }}>── Lower limit: 6.5</span>
          </div>
        </div>
      )}

      {view === "Weekly Volume" && (
        <div className="stp-chart-card">
          <div className="stp-section-title">Weekly Inlet Volume (m³)</div>
          <div className="stp-bar-chart" style={{ height: 200 }}>
            {inlet.weeklyTrend.map(day => (
              <div key={day.day} className="stp-bar-col">
                <div className="stp-bar-val">{(day.volume / 1000).toFixed(1)}k</div>
                <div className="stp-bar-wrap">
                  <div className="stp-bar-fill" style={{ height: `${(day.volume / maxVolume) * 100}%`, background: "linear-gradient(180deg,#8b5cf6,#667eea)" }} />
                </div>
                <div className="stp-bar-lbl">{day.day}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* AI note */}
      <div className="stp-ai-strip">
        🤖 AI: Inlet TSS at 420 mg/L is elevated — check screen chamber for partial blockage. Peak load window 07:00–09:00 matches residential morning activity.
      </div>
    </div>
  );
};

export default StpInletPanel;
